import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { L, card } from "./shared";

const PIATT = ["Instagram Reel", "Instagram Story", "Instagram post video", "Facebook Reel", "Facebook video"];
const OBI = [["awareness", "Awareness"], ["lead", "Lead"], ["vendita", "Vendita"], ["engagement", "Engagement"], ["brand", "Brand"]];
const DUR = [15, 30, 45, 60, 90];

const Sel = ({ value, onChange, items, testid }) => (
  <Select value={String(value)} onValueChange={onChange}>
    <SelectTrigger className="rounded-xl bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{items.map(([v, l]) => <SelectItem key={v} value={String(v)}>{l}</SelectItem>)}</SelectContent>
  </Select>
);

export const ScriptForm = ({ clientId, initial, onCreated }) => {
  const [f, setF] = useState({ piattaforma: PIATT[0], obiettivo: "engagement", durata: 30, tono: "", tema: "", punti: "", cta: "", riferimento: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (initial) setF((p) => ({ ...p, ...initial })); }, [initial]);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));
  const go = async () => {
    if (f.tema.trim().length < 2) return toast.error("Indica prodotto, servizio o tema");
    setBusy(true);
    try { onCreated((await api.post(`/admin-ai/clients/${clientId}/script/genera`, { ...f, durata: Number(f.durata) })).data); toast.success("Script generato"); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className={card} data-testid="script-form">
      {initial?.tema && <div className="mb-3 rounded-xl bg-white/80 border border-emerald-600/40 px-3 py-2 text-xs font-semibold text-emerald-900" data-testid="script-form-from-idea">Brief precompilato dall'idea «{initial.tema}». Controlla e genera.</div>}
      <div className="grid gap-3 sm:grid-cols-3">
        <div><L>Piattaforma</L><Sel value={f.piattaforma} onChange={set("piattaforma")} items={PIATT.map((p) => [p, p])} testid="script-form-piattaforma" /></div>
        <div><L>Obiettivo</L><Sel value={f.obiettivo} onChange={set("obiettivo")} items={OBI} testid="script-form-obiettivo" /></div>
        <div><L>Durata</L><Sel value={f.durata} onChange={set("durata")} items={DUR.map((d) => [d, `${d} secondi`])} testid="script-form-durata" /></div>
        <div className="sm:col-span-2"><L>Prodotto / servizio / tema</L><Input value={f.tema} onChange={set("tema")} className="rounded-xl bg-white" data-testid="script-form-tema" /></div>
        <div><L>Tono</L><Input value={f.tono} onChange={set("tono")} placeholder="es. ironico, elegante" className="rounded-xl bg-white" data-testid="script-form-tono" /></div>
        <div className="sm:col-span-2"><L>Punti chiave</L><Textarea rows={2} value={f.punti} onChange={set("punti")} className="rounded-xl bg-white" data-testid="script-form-punti" /></div>
        <div><L>CTA</L><Input value={f.cta} onChange={set("cta")} placeholder="es. Prenota ora" className="rounded-xl bg-white" data-testid="script-form-cta" /></div>
        <div className="sm:col-span-3"><L>Riferimento (link o idea, facoltativo)</L><Input value={f.riferimento} onChange={set("riferimento")} className="rounded-xl bg-white" data-testid="script-form-riferimento" /></div>
      </div>
      <Button onClick={go} disabled={busy} className="mt-4 w-full sm:w-auto rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="script-form-generate">
        {busy ? <><Loader2 className="h-4 w-4 mr-1.5 animate-spin" />Sto scrivendo lo script…</> : <><Sparkles className="h-4 w-4 mr-1.5" />Genera script</>}
      </Button>
    </div>
  );
};
